import { createFileRoute } from '@tanstack/react-router';
import { CashPage } from '../../features/settlement';

export const Route = createFileRoute('/portal/settlement/cash')({ component: CashPage });
